module.exports = "https://deal-img.imgix.net/consumer/safari.191bfe5b.png";